import { Injectable } from '@angular/core';
// import { RequestOptions, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/defer';
import { ApiService } from '../api.service';
import { ApiQueryParams } from './api-query-params';
import { forkJoin } from '../../../../node_modules/rxjs/observable/forkJoin';

@Injectable()
export class InvoiceService {
    private options: any;

    constructor(
        private apiService: ApiService
    ) {
        // const headers = new Headers({ 'Content-Type': 'application/json' });
        // this.options = new RequestOptions({ headers: headers });
        // this.apiService.init();
    }

    getByfilter(query: ApiQueryParams): Observable<any[]> {
        return this.apiService.client.invoices.GET(query.fields, query.filter, query.sort, query.page, query.opts)
            .map((res) => {
                return this.apiService.handleResponse(res);
            });
    }

    getAll(query: ApiQueryParams): Observable<any[]> {
        return this.apiService.client.invoices.GET(query.fields, query.filter, query.sort, query.page, query.opts)
            .map(
                (res) => {
                    return this.apiService.handleResponse(res);
                }
            )
    }

    getCount(filter: string): Observable<any> {
        return this.getByfilter({
            filter: filter,
            aggregatedFields: 'Count()'
        })
    }

    getInvoiceWithCount(query: ApiQueryParams): Observable<any> {
        const dataQuery = this.getByfilter(query);
        const countQuery = this.getCount(query.filter);
        return forkJoin([dataQuery, countQuery]);
    }

    getPropertiesById(id: string): Observable<any[]> {
        return this.apiService.client.properties.invoice.GET(null, `Id eq ${id}`)
        .map((res) => {
                return this.apiService.handleResponse(res);
        });
    }

    getPropertiesByFilter(query: ApiQueryParams): Observable<any[]> {

        return this.apiService.client.properties.invoice.GET(query.fields, query.filter, query.sort, query.page, query.opts)
            .map((res) => {
                return this.apiService.handleResponse(res);
            });
    }

    getQRCode(ucId: string): Observable<any> {
        return this.apiService.client.invoices.qrcode.GET(ucId)
        .map((res) => {
                return this.apiService.handleResponse(res);
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/core/api/invoice.service.ts